export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const CLEAR_FAILED_DOCUMENTS = 'CLEAR_FAILED_DOCUMENTS';
export const GET_SAVED_DOCCHAT_HISTORY = 'GET_SAVED_DOCCHAT_HISTORY';
export const SELECTED_DOCUMENT_INFO = 'SELECTED_DOCUMENT_INFO';
export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const FEEDBACK_SENT = 'FEEDBACK_SENT';
